(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (document.body.classList.contains('transparent-header')) {
        this.header.classList.remove('scrolled-past-header');
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

      this.setHeaderHeight();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onMediaChangeHandler = this.setHeaderHeight.bind(this);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onMediaChangeHandler);
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      requestAnimationFrame(() => this.onScroll());
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      const headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        document.documentElement.style.setProperty('--header-group-height', `${headerGroup.offsetHeight}px`);
      }

      this.updateHeaderBounds();
    }

    updateScrolledHeaderHeight() {
      this.setHeaderHeight();
      clearTimeout(this.scrolledHeaderHeightTimeout);
      this.scrolledHeaderHeightTimeout = setTimeout(() => this.setHeaderHeight(), 400);
    }

    updateHeaderBounds() {
      if (document.body.classList.contains('transparent-header')) {
        const headerGroup = document.querySelector('.shopify-section-group-header-group');
        const height = headerGroup ? headerGroup.offsetHeight : this.header.offsetHeight;

        this.headerBounds = {
          top: 0,
          bottom: height,
          height,
          left: 0,
          right: window.innerWidth,
          width: window.innerWidth,
        };
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      if (document.body.classList.contains('transparent-header')) {
        this.updateHeaderBounds();
        return;
      }

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const wasScrolledPast = this.header.classList.contains('scrolled-past-header');

      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(this.reset.bind(this));
        }
        if (wasScrolledPast) {
          this.updateScrolledHeaderHeight();
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (!wasScrolledPast) {
        this.updateScrolledHeaderHeight();
      }

      const hideThreshold = this.headerBounds.bottom || this.header.offsetHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > hideThreshold) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > hideThreshold) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
